import { IsOptional, IsString, IsBoolean } from 'class-validator';

export class BugDiagnosticsDTO {

    @IsOptional()
    @IsString()
    browser: string;

    @IsOptional()
    @IsString()
    system: string;

    @IsOptional()
    @IsString()
    agent: string;

    @IsOptional()
    @IsString()
    browserLanguage: string;

    @IsOptional()
    @IsString()
    browserVersion: string;

    @IsOptional()
    @IsBoolean()
    cookieEnabled: boolean;

    @IsOptional()
    @IsBoolean()
    online: boolean;

    @IsOptional()
    @IsString()
    screenWidth: string;
    
    @IsOptional()
    @IsString()
    screenHeight: string;

    @IsOptional()
    @IsString()
    systemLanguage: string;

}
